/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ItemsPaginationWrapper_portfolioNode$ref = any;
type ItemsRefetchWrapper_portfolioNode$ref = any;
type Recommendations_trending$ref = any;
type RequestShippingQuoteModal_viewer$ref = any;
type Tiles_viewer$ref = any;
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type FolderContainer_viewer$ref = any;
export type FolderContainer_viewer = {
    readonly id: string;
    readonly user?: {
        readonly serviceId: string | null;
        readonly isVerifiedTrade: boolean | null;
        readonly profile: {
            readonly currency: Currency | null;
            readonly email: string | null;
        } | null;
    } | null;
    readonly folderPortfolios?: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly serviceId: string | null;
                readonly name: string | null;
                readonly description: string | null;
                readonly isPublic: boolean | null;
                readonly ownerId: string | null;
                readonly totalPortfolioItems: {
                    readonly totalResults: number | null;
                } | null;
                readonly " $fragmentRefs": ItemsRefetchWrapper_portfolioNode$ref & ItemsPaginationWrapper_portfolioNode$ref;
            } | null;
        } | null> | null;
    } | null;
    readonly project?: {
        readonly portfolio: {
            readonly id: string;
            readonly serviceId: string | null;
            readonly name: string | null;
            readonly description: string | null;
            readonly isPublic: boolean | null;
            readonly ownerId: string | null;
            readonly totalPortfolioItems: {
                readonly totalResults: number | null;
            } | null;
            readonly " $fragmentRefs": ItemsRefetchWrapper_portfolioNode$ref;
        } | null;
    } | null;
    readonly " $fragmentRefs": Recommendations_trending$ref & RequestShippingQuoteModal_viewer$ref & Tiles_viewer$ref;
    readonly " $refType": FolderContainer_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "Literal",
        "name": "first",
        "value": 1
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "description",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isPublic",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "ownerId",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "LinkedField",
        "alias": "totalPortfolioItems",
        "name": "items",
        "storageKey": "items(first:1)",
        "args": [
            (v2 /*: any*/)
        ],
        "concreteType": "PortfolioItemsConnection",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalResults",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v8 = ({
        "kind": "FragmentSpread",
        "name": "ItemsRefetchWrapper_portfolioNode",
        "args": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "FolderContainer_viewer",
        "type": "Viewer",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String!"
            },
            {
                "kind": "RootArgument",
                "name": "hasUserId",
                "type": "Boolean"
            },
            {
                "kind": "RootArgument",
                "name": "portfolioIds",
                "type": "[String]"
            },
            {
                "kind": "RootArgument",
                "name": "useProjectEndpoint",
                "type": "Boolean"
            },
            {
                "kind": "RootArgument",
                "name": "projectId",
                "type": "String!"
            }
        ],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "FragmentSpread",
                "name": "Recommendations_trending",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "RequestShippingQuoteModal_viewer",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "Tiles_viewer",
                "args": null
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "userId",
                                "variableName": "userId"
                            }
                        ],
                        "concreteType": "User",
                        "plural": false,
                        "selections": [
                            (v1 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isVerifiedTrade",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "profile",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Profile",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "currency",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "email",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "Condition",
                "passingValue": false,
                "condition": "useProjectEndpoint",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": "folderPortfolios",
                        "name": "portfolios",
                        "storageKey": null,
                        "args": [
                            (v2 /*: any*/),
                            {
                                "kind": "Variable",
                                "name": "portfolioIds",
                                "variableName": "portfolioIds"
                            }
                        ],
                        "concreteType": "PortfoliosConnection",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PortfoliosEdge",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "PortfolioV2",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            (v1 /*: any*/),
                                            (v3 /*: any*/),
                                            (v4 /*: any*/),
                                            (v5 /*: any*/),
                                            (v6 /*: any*/),
                                            (v7 /*: any*/),
                                            (v8 /*: any*/),
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ItemsPaginationWrapper_portfolioNode",
                                                "args": null
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "useProjectEndpoint",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "project",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "id",
                                "variableName": "projectId"
                            }
                        ],
                        "concreteType": "Project",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "portfolio",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PortfolioV2",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    (v1 /*: any*/),
                                    (v3 /*: any*/),
                                    (v4 /*: any*/),
                                    (v5 /*: any*/),
                                    (v6 /*: any*/),
                                    (v7 /*: any*/),
                                    (v8 /*: any*/)
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '961439eda1d7f0ab771ad28a6beb0a76';
export default node;
